import { PageHeader, Section } from "@/components/site/PageChrome";
import { Target, Eye, ShieldCheck, Lightbulb, Handshake, Zap } from "lucide-react";

export default function AboutDigiswingPage() {
  const values = [
    { icon: Lightbulb, t: "Innovation with purpose", d: "We build technology that solves real, everyday problems." },
    { icon: Handshake, t: "Community first", d: "Products that create value for individuals, businesses, and cities." },
    { icon: ShieldCheck, t: "Trust & transparency", d: "No hidden fees, no dark patterns — clarity in everything we ship." },
    { icon: Zap, t: "Practical & scalable", d: "Solutions designed to grow with the people who use them." },
  ];
  return (
    <>
      <PageHeader
        eyebrow="About DIGISWING"
        title="DIGISWING Innovation Private Limited."
        subtitle="An Indian technology company building digital products that solve real-world problems — Time2Cash is our flagship platform."
      />
      <Section>
  <div className="relative flex justify-center mb-12">

    {/* Left Glow */}
    <div className="absolute -left-24 top-1/2 -translate-y-1/2 w-56 h-56 bg-orange-300/20 rounded-full blur-3xl animate-pulse" />

    {/* Right Glow */}
    <div className="absolute -right-24 top-1/2 -translate-y-1/2 w-56 h-56 bg-amber-200/30 rounded-full blur-3xl animate-pulse" />

    {/* Decorative Rings */}
    <div className="absolute w-72 h-72 rounded-full border border-orange-200/50 animate-pulse" />
    <div className="absolute w-80 h-80 rounded-full border border-orange-100/40" />

    {/* Logo Card */}
    <div className="relative bg-white rounded-[2rem] shadow-2xl border border-[#F3E8DD] p-8">
      <img
        src="/Media-Library/digiswing-logo.png"
        alt="DIGISWING Innovation Private Limited"
        className="h-40 md:h-52 w-auto object-contain drop-shadow-2xl transition-transform duration-500 hover:scale-105"
      />
    </div>

  </div>

  <div className="max-w-3xl mx-auto text-center">
    <p className="text-lg text-[#4A4846] leading-relaxed">
      DIGISWING Innovation Private Limited is focused on building digital
      products that strengthen local communities by connecting people,
      businesses, opportunities, and services through technology.
      <br /><br />
      <strong className="text-[#FF5A00]">Time2Cash</strong>, our flagship
      platform, reflects our belief that the best technology feels local,
      personal, and genuinely useful.
    </p>
  </div>
</Section>
      <Section>
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-lg text-[#4A4846] leading-relaxed">
            DIGISWING Innovation Private Limited is focused on building digital products that strengthen local communities by
            connecting people, businesses, opportunities, and services through technology. Time2Cash, our flagship platform,
            reflects our belief that the best technology feels local, personal, and genuinely useful.
          </p>
        </div>
      </Section>

      <Section className="bg-[#FFF9F5]">
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <div className="rounded-3xl border border-[#EBE8E3] bg-white p-8">
            <div className="w-12 h-12 rounded-2xl bg-[#FFF3ED] flex items-center justify-center">
              <Eye className="w-6 h-6 text-[#FF5A00]" />
            </div>
            <h3 className="mt-4 text-2xl font-bold text-[#1A1918]">Vision</h3>
            <p className="mt-2 text-[#4A4846]">To build practical, scalable solutions that create value for individuals, businesses, and cities.</p>
          </div>
          <div className="rounded-3xl border border-[#EBE8E3] bg-white p-8">
            <div className="w-12 h-12 rounded-2xl bg-[#FFF3ED] flex items-center justify-center">
              <Target className="w-6 h-6 text-[#FF5A00]" />
            </div>
            <h3 className="mt-4 text-2xl font-bold text-[#1A1918]">Mission</h3>
            <p className="mt-2 text-[#4A4846]">To strengthen local communities by connecting people and businesses through thoughtful, accessible technology.</p>
          </div>
        </div>
      </Section>

      <Section>
        <h2 className="text-3xl md:text-4xl font-bold text-[#1A1918] text-center">Our values.</h2>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map(({ icon: Icon, t, d }) => (
            <div key={t} className="rounded-3xl border border-[#EBE8E3] bg-white p-6">
              <Icon className="w-6 h-6 text-[#FF5A00]" />
              <h3 className="mt-4 font-bold text-[#1A1918]">{t}</h3>
              <p className="mt-2 text-sm text-[#4A4846]">{d}</p>
            </div>
          ))}
        </div>
      </Section>
    </>
  );
}
